import * as React from 'react';
import JcsdAccountListView from 'components/Client/JcsdAccountListView';

export interface Props {
  children?: React.ReactNode;
}

export interface State { }

export default class JcsdAccountListPage extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render() {
    return <JcsdAccountListView />;
  }
}



